import type { JourneyNode } from '../../entities/node';
import { hasInvalidTagValues } from './tag-rules';
export interface NodeValidationResult { valid: boolean; hints: string[]; }
export function validateNode(node: JourneyNode): NodeValidationResult {
  const hints: string[] = [];
  if (!node.displayName.trim()) hints.push('Display name is required.');
  if (hasInvalidTagValues(node.tags)) hints.push('Tags can only contain letters, numbers, and spaces. Use commas to separate multiple tags.');
  const fieldIds = new Set<string>();
  for (const field of node.customFields) { if (!field.label.trim()) hints.push('Custom field label is required.'); if (fieldIds.has(field.fieldId)) hints.push('Custom field ids must be unique.'); fieldIds.add(field.fieldId); }
  if (node.type === 'Project' && node.relatedProjectIds.includes(node.nodeId)) hints.push('Project cannot reference itself.');
  return { valid: hints.length === 0, hints };
}
